/**
 * Tujuan   : Kumpulan ikon SVG yang diekspor sebagai React component / URL asset
 * Caller   : Komponen UI (Navbar, Footer, Login, dll.)
 * Dependensi: file SVG di folder assets/svg
 * Main Functions: export named SVG icons
 * Side Effects: tidak ada
 */
import { ReactComponent as IcTelepon } from "./ic-telepon.svg";
import { ReactComponent as OrangLaptop } from "./orang-laptop.svg";
import { ReactComponent as IcLinkedIn } from "./ic-linkedin.svg";
import { ReactComponent as IcIg } from "./ic-ig.svg";
import { ReactComponent as IcFb } from "./ic-fb.svg";
import { ReactComponent as IcX } from "./ic-x.svg";
import { ReactComponent as IcMapsCircle } from "./ic-maps-circle.svg";
import { ReactComponent as IcMailCircle } from "./ic-mail-circle.svg";
import { ReactComponent as IcTeleponCircle } from "./ic-telepon-circle.svg";
import { ReactComponent as IcSearch } from "./ic-search.svg";
import { ReactComponent as IcCalendar } from "./ic-calendar.svg";
import { ReactComponent as IcCheck } from "./ic-check.svg";
import { ReactComponent as IcCheck2 } from "./ic-check2.svg";
import { ReactComponent as IcDocumentText } from "./ic-document-text.svg";
import { ReactComponent as IcArrowLeft } from "./ic-arrow-left.svg";
import { ReactComponent as IcArrowRight } from "./ic-arrow-right.svg";
import { ReactComponent as IcEye } from "./ic-eye.svg";
import { ReactComponent as IcMinus } from "./ic-minus.svg";
import { ReactComponent as IcPlus } from "./ic-plus.svg";
import { ReactComponent as IcAward } from "./ic-award.svg";
import { ReactComponent as IcCalendar2 } from "./ic-calendar2.svg";
import { ReactComponent as IcBuilding } from "./ic-building.svg";
import { ReactComponent as IcClose } from "./ic-close.svg";
import { ReactComponent as IcRefresh } from "./ic-refresh.svg";
import { ReactComponent as IcUpload } from "./ic-upload.svg";
import { ReactComponent as IcCalendar3 } from "./ic-calendar3.svg";
import { ReactComponent as IcUser } from "./ic-user.svg";
import { ReactComponent as IcLock } from "./ic-lock.svg";
import { ReactComponent as IcKontak } from "./ic-kontak.svg";
import { ReactComponent as IcMail } from "./ic-mail.svg";
import { ReactComponent as IcHomeBlue } from "./ic-home-blue.svg";
import { ReactComponent as IcStep5 } from "./ic-step5.svg";
import { ReactComponent as IcPanahBiru } from "./ic-panah-biru.svg";
import { ReactComponent as IcStep4 } from "./ic-step4.svg";
import { ReactComponent as IcStep3 } from "./ic-step3.svg";
import { ReactComponent as IcStep2 } from "./ic-step2.svg";
import { ReactComponent as IcStep1 } from "./ic-step1.svg";
import { ReactComponent as IcEdit } from "./ic-edit.svg";
import { ReactComponent as IcRegisterPage } from "./ic-registerpage.svg";

// Ornamen batik besar dipindahkan ke public/assets/svg agar tidak diproses SVGR/Babel
export const IcBatikAtas =
  process.env.PUBLIC_URL + "/assets/svg/ic-batik-atas.svg";
export const IcBatikBawah =
  process.env.PUBLIC_URL + "/assets/svg/ic-batik-bawah.svg";
export const IcLogBatikAtas =
  process.env.PUBLIC_URL + "/assets/svg/ic-logbatikatas.svg";
export const IcLogBatikBawah =
  process.env.PUBLIC_URL + "/assets/svg/ic-logbatikbawah.svg";

export {
  IcTelepon,
  OrangLaptop,
  IcLinkedIn,
  IcIg,
  IcFb,
  IcX,
  IcMapsCircle,
  IcMailCircle,
  IcTeleponCircle,
  IcSearch,
  IcCalendar,
  IcCheck,
  IcCheck2,
  IcDocumentText,
  IcArrowLeft,
  IcArrowRight,
  IcEye,
  IcMinus,
  IcPlus,
  IcAward,
  IcCalendar2,
  IcBuilding,
  IcClose,
  IcRefresh,
  IcUpload,
  IcCalendar3,
  IcUser,
  IcLock,
  IcKontak,
  IcMail,
  IcHomeBlue,
  IcStep5,
  IcPanahBiru,
  IcStep4,
  IcStep3,
  IcStep2,
  IcStep1,
  IcEdit,
  IcRegisterPage,
};
